'use strict';
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */

  var defaultSettings = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;

    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();

  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
(function() {
  const productSelector = '[selecteditemparent]';
  const viewedItems = new Set(); // Track processed items
  const jsonObjMap = new Map(); // Map to collect item data by sectionId
  const visibleProducts = new Map(); // Track currently visible products
  let totalRequests = 0; // Total number of AJAX requests
  let completedRequests = 0; // Number of completed AJAX requests

  // Create an IntersectionObserver instance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const productElement = entry.target;
      const productUrl = productElement.dataset.url;
      const sectionId = productElement.dataset.sectionid;
      const sectionname = productElement.dataset.sectionname;
      const datacategory = productElement.dataset.category;
      const productindex = parseInt(productElement.dataset.index, 10); // Ensure index is an integer
      if (entry.isIntersecting) {
        // Only fetch product data if it hasn't been fetched before
        if (!viewedItems.has(productUrl)) {
          // Mark this product as viewed
          viewedItems.add(productUrl);
          visibleProducts.set(productUrl, { sectionId }); // Track visible product

          // Increment totalRequests when a new request is initiated
          totalRequests++;
          // Fetch product data with AJAX using the URL
          fetchProductData(productUrl, sectionId, sectionname, productindex, datacategory);
        }
      } else {
        // If the product is no longer visible, remove from visibleProducts
        visibleProducts.delete(productUrl);
      }
    });
  }, { threshold: 0.5 }); // Adjust the threshold as needed

  // Observe each product element
  document.querySelectorAll(productSelector).forEach(product => {
    observer.observe(product);
  });

  function fetchProductData(productUrl, sectionId, sectionname, productindex, datacategory) {
    jQuery.ajax({
      type: 'GET',
      url: productUrl,
      dataType: 'json'
    }).then(function(productdata) {
      const jsonData = [];
   
      // Process product data
      const product = productdata.product;
      
      let variant_name = '';
      for (let i = 0; i < product.variants.length; i++) {
        variant_name += product.variants[i].title + ',';
      }
      const new_var_name = variant_name.slice(0, -1).trim();
      const main_price = parseInt(product.variants[0].price, 10);
      const compare_main_price = parseInt(product.variants[0].compare_at_price, 10);
      let discount_exist = 'NA';
      if (compare_main_price > main_price) {
        const discount_exist_2 = compare_main_price - main_price;
        discount_exist = "₹" + discount_exist_2.toString();
      }
      jsonData.push({
        item_id: product.id,
        item_name: product.title,
        coupon: "NA",
        discount: discount_exist,
        index: productindex,
        item_brand: product.vendor,
        item_list_id: sectionId,
        item_list_name: sectionname,
        item_category: datacategory,
        item_category2: product.product_type,
        item_variant: new_var_name,
        price: main_price,
        quantity: "1"
      });

      // Add the results to the map by sectionId
      if (!jsonObjMap.has(sectionId)) {
        jsonObjMap.set(sectionId, []);
      }
      jsonObjMap.get(sectionId).push(...jsonData);

      completedRequests++;
      
      // Push to dataLayer only when all visible products are processed
      if (completedRequests === visibleProducts.size && visibleProducts.size > 0) {
        window.dataLayer = window.dataLayer || [];
        
        // Sort and push items for each sectionId
        jsonObjMap.forEach((items, sectionId) => {
          // Sort items by productindex
          items.sort((a, b) => a.index - b.index);

          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: sectionId, // Use sectionId for item_list_id
              item_list_name: sectionname, // Use sectionId for item_list_name
              items: items
            }
          });
        });

        // Clear the map and reset counts for the next batch of requests
        jsonObjMap.clear();
        completedRequests = 0; // Reset completedRequests for the next batch
        visibleProducts.clear(); // Optionally, clear the visibleProducts if needed
      }
    }).fail(function(xhr, status, error) {
      console.error('Error fetching product data:', {
        url: productUrl,
        status: status,
        error: error,
        responseText: xhr.responseText
      });
    });
  }
})();
      this.initialize();
    }
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};